import React from "react";
import { Helmet, type HelmetProps } from "@dr.pogodin/react-helmet";
import useSiteMetadata from "../../hooks/use-site-metadata";
import OpenGraphMeta from "../OpenGraphMeta";
import favicon from "../../images/favicon.ico";

const generatePageUrl = (base: string, path: string = "/"): string => {
  try {
    const url = new URL(path, base);
    return url.toString();
  } catch (ex) {
    return base;
  }
};

const HTMLHead: React.FC<JQI.HTMLHeadProps> = ({
  title,
  path = "/",
  description,
  openGraph = {},
}) => {
  const siteMetadata = useSiteMetadata();
  description = !!description ? description : siteMetadata.description;

  const ogMetaProps = {
    url: generatePageUrl(siteMetadata.siteUrl, path),
    title: `${title} | ${siteMetadata.title}`,
    description,
    ...openGraph,
  } as JQI.OpenGraphMetaProps;

  const props = {
    htmlAttributes: {
      lang: "en",
    },
    title: `${title} | ${siteMetadata.title}`,
    meta: [
      {
        name: "description",
        content: description,
      },
    ],
    link: [
      {
        rel: "canonical",
        href: ogMetaProps.url,
      },
      {
        rel: "icon",
        type: "image/vnd.microsoft.icon",
        href: favicon
      }
    ]
  } as HelmetProps;

  return (
    <>
      <Helmet {...props} />
      <OpenGraphMeta {...ogMetaProps} />
    </>
  );
};

export default HTMLHead;